import { useState } from "react";

type Props = {
  label?: string;
  question?: string;
  confirmLabel?: string;
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
};

export default function ConfirmRemove({
  label = "Retirer",
  question = "Retirer ?",
  confirmLabel = "Retirer",
  busy = false,
  onConfirm,
}: Props) {
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const locked = busy || sending;

  async function go() {
    if (locked) return;
    setSending(true);
    try {
      await onConfirm();
      setOpen(false);
    } finally {
      setSending(false);
    }
  }

  if (!open) {
    return (
      <button type="button" className="pr-btn-ghost" onClick={() => setOpen(true)}>
        {label}
      </button>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm text-slate-600">{question}</span>
      <button type="button" className="pr-btn" disabled={locked} onClick={() => void go()}>
        {sending ? "Suppression…" : confirmLabel}
      </button>
      <button type="button" className="pr-btn-ghost" disabled={locked} onClick={() => setOpen(false)}>
        Annuler
      </button>
    </div>
  );
}
